<div class="content-container margin-bottom margin-xl-top">
    <mat-card 
        appearance="outlined"
        class="timesheet-status"
    >
        <mat-card-content>
            <h1 class="margin-top-none">Unauthorized</h1>
            <p class="margin-top-none">
                You ({{ authenticatedUser }}) are not an authorized user of this system. If you believe this is in error, please contact the ITS Help Desk
                using the information in the footer of this page.
            </p>
            <p>
                <button mat-stroked-button (click)="logout()" style="float: right;">Logout</button>
            </p>
        </mat-card-content>
    </mat-card>
</div>
